import React, { useState } from 'react';
import { Image } from 'react-native';
import {
    BodyLargeEmphasized,
    BodyMediumRegular,
    Shadows,
    YStack,
} from 'smoothie';

import ScanningInProgressTopperImage from '../../../../assets/images/bills/scanning_bills.png';

const BillsScanningInProgress = () => {
    const [widthTopper, setWidthTopper] = useState(0);
    const [heightTopper, setHeightTopper] = useState(0);

    return (
        <YStack
            gap={16}
            paddingBottom={20}
            justifyContent="space-between"
            borderRadius="$5"
            borderWidth={1}
            borderColor="$gray200"
            flex={1}
            backgroundColor="$white"
            {...Shadows.SMALL}
            onLayout={(event) => {
                const width = event.nativeEvent.layout.width;
                const height =
                    event.nativeEvent.layout.width * (330 / 1035) - 40;
                setWidthTopper(width);
                setHeightTopper(Math.min(height, 150));
            }}
        >
            <YStack
                borderTopLeftRadius="$5"
                borderTopRightRadius="$5"
                overflow="hidden"
            >
                <Image
                    source={ScanningInProgressTopperImage}
                    style={{
                        width: widthTopper,
                        height: heightTopper,
                    }}
                />
            </YStack>
            <YStack paddingHorizontal={20}>
                <BodyLargeEmphasized textAlign="left">
                    We&apos;re scanning your accounts for bills
                </BodyLargeEmphasized>
                <BodyMediumRegular
                    textAlign="left"
                    color="$gray1000"
                    paddingVertical={8}
                >
                    This may take up to 20 minutes. We&apos;ll let you know when
                    they&apos;re ready for you to review.
                </BodyMediumRegular>
            </YStack>
        </YStack>
    );
};

export default BillsScanningInProgress;
